import React, {PropTypes as T} from 'react';
import { findDOMNode } from 'react-dom';
import './anchor.less';
import { Portal } from 'b3';
import { OutsideClickHandler } from 'b3';

export default class Anchor extends React.Component {

    static propTypes = { 
    	target: T.object.isRequired,
    	position: T.string,
    	align: T.string,
        onMouseOver: T.func,
        onMouseOut: T.func,
        onOutsideClick: T.func,
    };

    static defaultProps = { 
    	position: 'bottom',
    	align: 'left',
        onMouseOver: () => {},
        onMouseOut: () => {},
        onOutsideClick: () => {},
    };

    constructor(props) {
    	super(props);
    	this.state = {};
    }

    componentDidMount() {
    	if (this.props.target) {
    		this.init(this.props.target);
    	}
    }

    componentWillReceiveProps(nextProps) {
    	if (nextProps.target) {
    		this.init(nextProps.target);
    	}
    }

    init(target) {

    	var { position, align } = this.props;

    	var body = findDOMNode(this).closest('.b3-virtual-body') || document.body;

    	var targetEl = findDOMNode(target);

    	var offsets = this.getOffsetsRelativeToAncestor(targetEl, body);
    	var rect = targetEl.getBoundingClientRect();

		var style = {
			top: offsets.top,
			left: offsets.left,
		};

		var innerStyle = {};
		var innerMostStyle = {};

		if (position == 'top') {
			innerStyle.width = rect.width;
			innerMostStyle.bottom = 0;
		}
		else if (position == 'bottom') {
			innerStyle.top = rect.height;
			innerStyle.width = rect.width;
			innerMostStyle.top = 0;
		}
		else if (position == 'left') {
			innerStyle.height = rect.height;
			innerMostStyle.right = 0;
		}
		else if (position == 'right') {
			innerStyle.left = rect.width;
			innerStyle.height = rect.height;
		}

		if (align == 'top') {
			innerMostStyle.top = 0;
		}
		else if (align == 'bottom') {
			innerMostStyle.bottom = 0;
		}
		else if (align == 'left') {
			innerMostStyle.left = 0;
		}
		else if (align == 'right') {
			innerMostStyle.right = 0;
		}
		else if (align == 'center') {

			if (position == 'top' || position == 'bottom') {
				innerMostStyle.left = '50%';
				innerMostStyle.transform = 'translateX(-50%)';
			}
			else if (position == 'left' || position == 'right') {
				innerMostStyle.top = '50%';
				innerMostStyle.transform = 'translateY(-50%)';
			}
			
		}
		else if (align == 'both') {

			if (position == 'top' || position == 'bottom') {
				innerMostStyle.left = 0;
				innerMostStyle.right = 0;
			}
			else if (position == 'left' || position == 'right') {
				innerMostStyle.top = 0;
				innerMostStyle.bottom = 0;
			}

		}

    	this.setState({ 
    		style, 
    		innerStyle,
    		innerMostStyle,
    	});

    }

	getOffsetsRelativeToAncestor(elem, ancestor) {
	    var offsetLeft = 0;
	    var offsetTop = 0;

	    while (true)
	    {
	        offsetLeft += elem.offsetLeft;
	        offsetTop += elem.offsetTop;

	        if (elem.parentElement == ancestor
	        	|| elem.offsetParent == null
	        	|| elem.offsetParent.contains(ancestor)) //make sure we haven't traversed outside of our ancestor
	        {
	            break;
	        }

	        elem = elem.offsetParent;
	    }

	    return { top: offsetTop, left: offsetLeft };
	} 

	render() {
        return (
            <Portal>
            	<OutsideClickHandler onOutsideClick={this.props.onOutsideClick}>
		            <div style={this.state.style} className="b3-anchor" onMouseOver={this.props.onMouseOver} onMouseOut={this.props.onMouseOut}>
		            	<div style={this.state.innerStyle} className="b3-anchor-inner">
		            		<div style={this.state.innerMostStyle} className="b3-anchor-inner-most">
			        			{this.props.children}
			        		</div>
			        	</div>
		            </div>
	            </OutsideClickHandler>
            </Portal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/anchor/Anchor.js